const LagerEntnahmeSchein = (
    { street, housenumber, postalcode, town, manager, object_id, created, order_id, comment, object_note, company, products }:
        { street?: string, housenumber?: string, postalcode?: string, town?: string, manager?: string, object_id?: string, created?: string, order_id?: string, comment?: string, object_note?: string, company?: string, products?: any }) => {

    const formatText = (text: string | undefined, defaultChar: string = ''): string => {
        if (!text) return defaultChar; // Return a placeholder if the comment is empty
        return (`${text}`)
            .trim() // Remove leading and trailing spaces
            .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
            .replace(/\n/g, '<br />') // Replace newlines with <br />
            .replace(/\t/g, ' '); // Replace tabs with a single space
    };

    return (
        <div className="container">
            <div className="header">
                <div className="customer-address">
                    <strong>Lieferanschrift</strong><br />
                    {formatText(company)}<br />
                    {formatText(street)} {formatText(housenumber)} <br />
                    {formatText(postalcode)} {formatText(town)}

                    <div className="project-info">
                        <strong>Objektleiter:</strong> {formatText(manager, '-')}<br />
                        <strong>Objektnummer:</strong> {formatText(object_id)}<br />
                        <strong>Bestelldatum:</strong> {formatText(created)}
                    </div>
                </div>

                <div className="company-info">
                    <img src="/logo.png" alt="Firmenlogo" className="logo" /><br />
                    Haster Gebäudereinigungs GmbH<br />
                    Nürnberger Straße 6<br />
                    30855 Langenhagen
                </div>
            </div>

            <div className="document-title">Lagerentnahmeschein {formatText(order_id)}-1</div>

            <div className="additional-info">
                Weitere Informationen: '{formatText(object_note)}'
            </div>

            <table>
                <thead>
                    <tr>
                        <th>Pos.</th>
                        <th>Art. Nr.</th>
                        <th>Beschreibung</th>
                        <th>Menge</th>
                    </tr>
                </thead>
                <tbody>
                    {(products || []).sort((a: any, b: any) => a.article_number - b.article_number).map((product: any, index: number) => (
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td>{product.article_number}</td>
                            <td>{product.name}</td>
                            <td>{product.units_after} {product.unit_name ? `${product.unit_name}` : ''}</td>
                        </tr>
                    ))}
                    {/* Beispielzeilen */}
                </tbody>
            </table>

            <div className="additional-info">
                Kommentar aus der Bestellung: '{formatText(comment)}'
            </div>
        </div>
    );
};

export default LagerEntnahmeSchein;